import React from 'react';
import styled from 'styled-components'
import Video from '../Video'
const FramedVideoWrapper = styled.div`
.framed-video-grid {
    display: grid;
    column-gap: 1rem;
    grid-template-columns: [spacer] 2fr [image] 8fr [spacer] 2fr;
}
.framed-video-grid.vertical {
    grid-template-columns: [spacer] 4fr [image] 4fr [spacer] 4fr;
}
.framed-video {
    grid-area: image;
}
video {
    width: 100%;
    max-width: auto;
}
@media all and (max-width: 767px) {
    .framed-video-grid, .framed-video-grid.vertical {
        grid-template-columns: [spacer] 1fr [image] 10fr [spacer] 1fr;
    }
}
`
const FramedVideo = ({videoURL, altText, poster, vertical}) => {
  return (
      <FramedVideoWrapper className="row-component">
          <div className={vertical ? "framed-video-grid vertical":"framed-video-grid"}>
              <div className="framed-video">
                  <Video videoURL={videoURL} altText={altText} poster={poster} />
              </div>
          </div>
      </FramedVideoWrapper>
  )
};

export default FramedVideo;
